import { useEffect, useState } from 'react';

const START_SECONDS = 17 * 60 + 34; // 00:17:34

export function useCountdown() {
  const [left, setLeft] = useState(START_SECONDS);

  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft((prev) => (prev <= 0 ? START_SECONDS : prev - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  return {
    hours: Math.floor(left / 3600),
    minutes: Math.floor((left % 3600) / 60),
    seconds: left % 60,
  };
}
